var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgF(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 62,
    viewBox: "0 0 61 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0991 61.7668C27.241 62.9294 17.0966 59.6963 8.59192 53.1622C4.01532 49.6491 1.28805 44.965 0.410109 39.1098C-0.705721 31.7102 0.455421 25.1224 3.89354 19.3464C9.97113 9.1295 18.8496 2.77082 30.529 0.270347C32.1206 -0.0690844 33.7604 -0.0888908 35.4483 0.21094C45.4823 1.99295 52.8909 6.90623 57.3005 15.8587C61.4296 24.2342 62.4237 33.611 58.4984 42.1901C56.5018 46.5518 53.6471 51.1256 50.7329 54.9951C47.6743 59.0429 43.1713 61.2237 38.0991 61.7668Z",
    fill: "#F3E2C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8643 33.1311H32.707V45.5476H27.1639V33.1311H22.6186V28.0315H27.1639V24.0959C27.1639 19.6614 29.8246 17.167 33.871 17.167C35.8111 17.167 37.862 17.555 37.862 17.555V21.9341H35.5894C33.3721 21.9341 32.707 23.2644 32.707 24.7056V28.0315H37.6403L36.8643 33.1311Z",
    fill: "#4B2C5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF);
export default __webpack_public_path__ + "static/media/f.646227ad3a47db03b8674654d0715816.svg";
export { ForwardRef as ReactComponent };